export const BLOCKCHAIN = {
  TRON: { code: 'trx', name: 'Tron', },
  ETHEREUM: { code: 'eth', name: 'Ethereum', },
} as const;
